"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KnowledgeSelectionManager = void 0;
/**
 * Static helper class for managing knowledge selection state and logic
 */
class KnowledgeSelectionManager {
    /**
     * Parse comma-separated IDs string into clean array
     */
    static parseIdString(idString) {
        if (!idString)
            return [];
        return [...new Set(idString.split(',').filter(id => id && id.trim() !== ''))];
    }
    /**
     * Convert ID array to comma-separated string
     */
    static arrayToIdString(idArray) {
        const cleanIds = [...new Set(idArray.filter(id => id && id.trim() !== ''))];
        return cleanIds.join(',');
    }
    /**
     * Add knowledge ID to selection array (avoiding duplicates)
     */
    static addKnowledgeId(selectedIds, knowledgeId) {
        const idString = String(knowledgeId);
        if (!selectedIds.includes(idString)) {
            return [...selectedIds, idString];
        }
        return selectedIds;
    }
    /**
     * Remove knowledge ID from selection array
     */
    static removeKnowledgeId(selectedIds, knowledgeId) {
        const cleanKnowledgeId = String(knowledgeId).trim();
        return selectedIds.filter(id => String(id).trim() !== cleanKnowledgeId);
    }
    /**
     * Update selected knowledge based on current knowledge entries
     */
    static updateSelectedKnowledge(knowledgeEntries, selectedIds) {
        return knowledgeEntries.filter(k => selectedIds.includes(k.id.toString()));
    }
    /**
     * Merge manual and project-based selections
     */
    static mergeSelections(manualIds, projectKnowledgeMap) {
        const allProjectKnowledgeIds = Array.from(projectKnowledgeMap.values()).flat();
        return [...new Set([...manualIds, ...allProjectKnowledgeIds])];
    }
    /**
     * Check if knowledge ID is in full mode
     */
    static isKnowledgeInFullMode(knowledgeId, fullKnowledgeIds) {
        return fullKnowledgeIds.includes(knowledgeId);
    }
    /**
     * Toggle knowledge full mode
     */
    static toggleKnowledgeFullMode(knowledgeId, fullKnowledgeIds, shouldBeInFullMode) {
        const currentlyInFullMode = fullKnowledgeIds.includes(knowledgeId);
        if (shouldBeInFullMode && !currentlyInFullMode) {
            return [...fullKnowledgeIds, knowledgeId];
        }
        else if (!shouldBeInFullMode && currentlyInFullMode) {
            return fullKnowledgeIds.filter(id => id !== knowledgeId);
        }
        return fullKnowledgeIds;
    }
    /**
     * Remove knowledge from project selections
     */
    static removeKnowledgeFromProject(projectKnowledgeMap, projectId, knowledgeId) {
        const newMap = new Map(projectKnowledgeMap);
        const projectKnowledgeIds = newMap.get(projectId) || [];
        const updatedIds = projectKnowledgeIds.filter(id => id !== knowledgeId);
        newMap.set(projectId, updatedIds);
        return newMap;
    }
    /**
     * Remove entire project from selections
     */
    static removeProject(selectedProjects, projectKnowledgeMap, projectId) {
        const updatedProjects = selectedProjects.filter(p => p.id.toString() !== projectId);
        const updatedMap = new Map(projectKnowledgeMap);
        updatedMap.delete(projectId);
        return {
            projects: updatedProjects,
            knowledgeMap: updatedMap
        };
    }
}
exports.KnowledgeSelectionManager = KnowledgeSelectionManager;
